import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=88ea1820"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports